import { ReactNode } from 'react';

import { EditButton } from '../EditButton';
import SidebarSectionAction from './SidebarSectionAction';
import SidebarSectionContent from './SidebarSectionContent';
import SidebarSectionHeader from './SidebarSectionHeader';
import SidebarSectionRoot from './SidebarSectionRoot';
import SidebarSectionTitle from './SidebarSectionTitle';

export type SidebarSectionEditableProps = {
  title: string;
  onEdit: () => void;
  children?: ReactNode;
};

export const SidebarSectionEditable = ({
  title,
  onEdit,
  children,
}: SidebarSectionEditableProps) => (
  <SidebarSectionRoot>
    <SidebarSectionHeader>
      <SidebarSectionTitle>{title}</SidebarSectionTitle>
      <SidebarSectionAction>
        <EditButton size="small" onClick={onEdit} />
      </SidebarSectionAction>
    </SidebarSectionHeader>
    <SidebarSectionContent>{children}</SidebarSectionContent>
  </SidebarSectionRoot>
);

SidebarSectionEditable.displayName = 'SidebarSection.Editable';
